var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrashWhite = function SvgTrashWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.92,
    height: 21.911
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4595"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon feather-trash-2",
    fill: "none",
    stroke: "#eff0f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105833",
    d: "M1 4.982h17.92"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105834",
    d: "M16.929 4.982V18.92a1.991 1.991 0 0 1-1.991 1.991H4.982a1.991 1.991 0 0 1-1.991-1.991V4.982m2.987 0V2.991A1.991 1.991 0 0 1 7.969 1h3.982a1.991 1.991 0 0 1 1.991 1.991v1.991"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105835",
    d: "M7.969 9.96v5.973"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 105836",
    d: "M11.951 9.96v5.973"
  })))));
};
export default SvgTrashWhite;